import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { SessionService } from "@/core/session.service";

export const resetGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const sessionService: SessionService = inject(SessionService);
  const router: Router = inject(Router);
  const validationCode = route.queryParamMap.get('validationCode');

  if (validationCode && !sessionService.settings()) {
    return true;
  } else if (sessionService.settings()) {
    return router.createUrlTree(['/']);
  } else {
    router.navigateByUrl(`/error/403`, { skipLocationChange: true });
    return false;
  }
};
